
export default {

    data() {
       
        return {
            booShow:false,
            classIcon:'fa fa-angle-double-right catalog-icon hand',
            nowTime:0,
            sumTime:0,
            videoObj: '',
            isImg: true,
            testId: '',
            chapterIndex: '',
            classIndex: '',
            className: '',
            classDetails: {},
            timer:null,
            booMove:false,
            videoUrl: '',
            lessonid:'',
            //项目任务
            assignment:[],
            src: require('../../assets/images/arrows-right.png'),
        }

    },
    methods: {
       
        //按钮移动
        pushcode: function(){
            this.booMove=!this.booMove;
             if(!this.booMove){
                this.$refs.move.style.left='0px';
                this.classIcon='fa fa-angle-double-right catalog-icon hand';              
             }else{
                this.$refs.move.style.left='350px';
                this.classIcon='fa fa-angle-double-left catalog-icon hand';
             }
       
            // return this.pushcat=true
            // return this.$router.style['left']="300px";
        },
         // 切换模式
        toresources: function(n){
            //  console.log(n)
        },

        //获取目录信息
        getdata(){
            
            // JSON.parse(this.$route.query.items_resources)
            // this.$route.query.url
            // console.log(JSON.parse(this.$route.query.items_resources))
            this.assignment = JSON.parse(this.$route.query.items_resources);
            // console.log(this.assignment)
            this.videoUrl= this.$route.query.url
            this.booShow=true;
            // console.log(this.assignment)
        },

        //点击视频章节切换不同视频
        toLearnVideo(tabId,resources) {
            // console.log(tabId)
            this.lessonid =tabId
            let resources_url1 = '';
            this.$post('resources/get', { id: this.lessonid, token: this.$store.state.id }).then(res => {
                resources_url1 = res.data.result.data;
                // console.log(resources_url1)
                this.videoUrl=resources_url1;
                this.videoPlay()
            })
        },

        //创建保利威视的视频对象
        videoPlay (url, time ,resources_url1) {
            let numVal = ((1 - 140 / document.body.offsetHeight));
            let eleHeight = document.body.offsetHeight * numVal;
            var player = polyvObject(
                "#plv_1"
            ).videoPlayer({
                width: 800,
                height: [eleHeight],
                vid: this.videoUrl,
                'flashvars': {'ban_history_time': 'on' }
            });
            this.videoObj = player;
        }
        //回课程学习页面
        // toClassStudy: function () {
            
        //     this.$router.push({
        //         path: '/classstudy',
        //         query: {
        //             id: this.$route.query.id
        //         }
        //     })
        // },
        //去课后习题页面
        // toClassExam: function () {
             
        //     UIkit.offcanvas(document.querySelector('#offcanvas-push')).hide();
        //     this.$router.push({
        //         path: '/classexam',
        //         query: {
        //             id: this.testId,
        //             goodsId: this.$route.query.goodsId
        //         }
        //     })
        // },
        //获取课程的基本信息
        // this.$post('products/get', { id: this.$route.query.classId }).then(res => {
        //     // console.log(res.data.result);
        //     this.classDetails = res.data.result;
        // })
       
    },
    mounted: function () {
         this.getdata()
         this.videoPlay()
    },
    created: function () {
         
       
    },
    
}